// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"d01aac64","591":"b2c5a083"}[chunkId] + ".chunk.css";
};